<div id="fsModal" class="modal-popup">
  <!-- Modal Content -->
  <div id="fsModalContent" class="modal-popup-content"></div>
  <div id="fsModalMiniPopUp" class="modal-mini-popup">
    <!-- Modal Content -->
    <div id="fsModalMiniContentPopup" class="modal-mini-popup-content"></div>
  </div>
</div>

<div id="fsModalMessage" class="modal-mini-popup">
  <!-- Modal Content -->
  <div id="fsModalMessageContent" class="modal-mini-popup-content"></div>
</div>
<!--<div class="workspace-spinner" style="text-align:center;">
  <div class="fa fa-spinner fa-spin-details"></div>
</div>-->
<div class="video-spinner" style="display: block;">
  <div class="" data-fa-i2svg="">
    <svg class="svg-inline--fa fa-spinner fa-w-16 fa-spin" aria-hidden="true" focusable="false" data-prefix="fa" data-icon="spinner" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"></path></svg>
  </div>
</div>
